import trainEvents from './../config/train-events';

export default function TrainsMapButtonController(
    $scope,
    $rootScope
) {
    'ngInject';

    $scope.controlClick = function() {
        $rootScope.$broadcast(trainEvents.MAP_SHOW_HIDE_RATES);
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/controllers/trains-map-button-controller.js